export default __webpack_public_path__ + "static/media/flechaizq.dcd19fa6.svg";